import { Layout, ActiveSavedAlerts } from 'components/widgets';
import { Saved } from 'components/containers';
import { usePathIndicator } from 'hooks';
import { LINKS } from 'utils/constants';

export default function SavedPage() {
  usePathIndicator(LINKS.saved);

  return (
    <Layout sidebar={<ActiveSavedAlerts />}>
      <Saved />
    </Layout>
  );
}
